import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';

// import { EmbedOptionsComponent } from './embed-options/embed-options.component';
import { EmbedPreviewComponent } from '../../shared/picker/embed-preview/embed-preview.component';
import { EmbedOptionsComponent } from '../../shared/picker/embed-options/embed-options.component';
import { EmbedPickerIframeComponent } from '../../shared/picker/embed-picker-iframe/embed-picker-iframe.component';
import { DomSanitizer } from '@angular/platform-browser';

interface DialogData {
  ministryID: number;
}

@Component({
    selector: 'zwi-ministry-embed-picker',
    imports: [
        FormsModule,
        MatButtonModule,
        MatDialogActions,
        MatDialogClose,
        MatDialogContent,
        MatDialogTitle,
        MatIconModule,
        MatInputModule,
        MatFormFieldModule,
        MatSelectModule,
        MatCheckboxModule,
        EmbedOptionsComponent,
        EmbedPreviewComponent,
        EmbedOptionsComponent,
        EmbedPickerIframeComponent,
    ],
    templateUrl: './ministry-embed-picker.component.html',
    styleUrl: './ministry-embed-picker.component.scss'
})
export class MinistryEmbedPickerComponent {
  height = 752;
  width = '100%';

  constructor(
    public dialogRef: MatDialogRef<MinistryEmbedPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private cdRef: ChangeDetectorRef,
    @Inject(DomSanitizer) private domSanitizer: DomSanitizer
  ) {}

  close() {
    this.dialogRef.close();
  }

  setHeight(h: number) {
    this.height = h;
  }

  setWidth(w: string) {
    this.width = w;
  }
}
